<template>
<bim-row id="bimlib-for-manufacturer" class="services-lending__showing-container" justify="start">
  <div class="showing__image-small">
    <img
      class="showing__image-img" 
      src="/dist/assets/front_white/img/services_lending/main-bg-small.png" 
      srcset="
        /dist/assets/front_white/img/services_lending/main-bg-small@2x.png 2x,
        /dist/assets/front_white/img/services_lending/main-bg-small@3x.png 3x
      "
    />
  </div>
  <bim-col class="services-lending__showing-text showing-text__content" cols="12" sm="6">
    <div class="showing-text__container">
      <p class="text-info">bimlib для производителей</p>
      <h1 class="text-title">Поможем вашей продукции оказаться на стройплощадке</h1>
      <p class="text-brief">Снарядим бесценной информацией для B2B продаж</p>
      <div class="text-button">
        <bim-button @click="$emit('showModal')" v-metric="'LENDING-BIM_CLICK-ON-SEND-REQUEST-TO-BUY-TARIFF'" class="mb-sm-9 get-access__button" size="l" label="Получить доступ"></bim-button>
      </div>
    </div>
  </bim-col>
  <div class="showing__image showing__image-big">
    <img 
      class="showing__image-img" 
      src="/dist/assets/front_white/img/services_lending/main-bg.png" 
      srcset="
        /dist/assets/front_white/img/services_lending/main-bg@2x.png 2x,
        /dist/assets/front_white/img/services_lending/main-bg@3x.png 3x
      "
    />
  </div>
</bim-row>
</template>

<script>
import bimRow from '@bimlib/components/bimRow'
import bimCol from '@bimlib/components/bimCol'

export default {
  name: "block-showing",
  components: {
    bimCol,
    bimRow
  }
}
</script>